import StartingEquipmentSlots from "./StartingEquipmentSlots";

export default StartingEquipmentSlots;
export { StartingEquipmentSlots };
